module.exports = __webpack_public_path__ + "static/media/align_left_w.b21cf27a.svg";